export default __webpack_public_path__ + "static/media/recommended.1e92cae3.svg";